import './spinner.scss'

const SpinnerOverlay = (props: any) => {
  return (
    <div className='spinner' data-testid="spinner">
      <div className='centered' />
    </div>
  )
}

export default SpinnerOverlay
